/**
 * Handles template updates for service and visitation templates.
 *
 * Template types:
 * - "service" / "default_service" - Finds default service (type="service" with default=true)
 * - "visitation" - Finds default visitation (type="visitation" with default=true)
 * - "specific_service" - Finds service by stored serviceId regardless of type/default
 */
export const handleServiceTemplateUpdate = ({
  key,
  properties,
  currentServices,
  element,
}) => {
  let targetService = null
  let serviceIdToUse = null
  let updatedTemplateProps = { ...properties }

  const isDefaultService = key === 'service' || key === 'default_service'
  const isDefaultVisitation = key === 'visitation'
  const isSpecificService = key === 'specific_service'

  if (isDefaultService) {
    // Find service with type="service" AND default=true
    targetService = currentServices.find(
      (s) => s.default === true && s.type?.toLowerCase() === 'service',
    )
    if (!targetService) {
      console.warn(
        'Default service template update requested, but no current default service found.',
      )
      element.remove()
      return null
    }
    serviceIdToUse = targetService.id
    updatedTemplateProps = { ...properties, serviceId: serviceIdToUse }
  } else if (isDefaultVisitation) {
    // Find service with type="visitation" AND default=true
    targetService = currentServices.find(
      (s) => s.default === true && s.type?.toLowerCase() === 'visitation',
    )
    if (!targetService) {
      console.warn(
        'Default visitation template update requested, but no current default visitation found.',
      )
      element.remove()
      return null
    }
    serviceIdToUse = targetService.id
    updatedTemplateProps = { ...properties, serviceId: serviceIdToUse }
  } else if (isSpecificService) {
    const storedServiceId = properties.serviceId
    if (!storedServiceId) {
      console.error(
        'Specific service template is missing serviceId in properties.',
      )
      element.remove()
      return null
    }
    targetService = currentServices.find((s) => s.id === storedServiceId)
    if (!targetService) {
      element.remove()
      return null
    }
    serviceIdToUse = storedServiceId
  }

  return updatedTemplateProps
}
